import { of, switchMap, tap, fromEvent, merge } from 'rxjs';

import { replaceViewContainer, renderTemplate } from './ui.js';
import { getSection, saveSection } from './knowledge-api.js';
import { buildWorkMonitor } from './working.js';

export function createSectionView(secId) {
    return of(undefined).pipe(
        switchMap(() => {
            let root = renderTemplate('section-view');
            replaceViewContainer(root);

            let saveMonitor = buildWorkMonitor();
            let saveIndicator$ = saveMonitor.showElements('.saving');
            let alertSavingBeforeUnload$ = saveMonitor.alertBeforeUnload();
            
            let form = root.querySelector('form');

            let section$ = getSection(secId);

            let populate$ = section$.pipe(
                tap(section => {
                    root.querySelector('.collection-title').textContent = `${section.collection_owner}/${section.collection_name}`;
                    let docLink = root.querySelector('.source-document');
                    docLink.textContent = section.doc_source_uri;
                    docLink.href = section.doc_source_uri;
                    root.querySelector('textarea[name=text]').value = section.text;
                }),
            );

            let save$ = fromEvent(form, 'submit').pipe(
                switchMap(event => {
                    event.preventDefault();
                    let text = (form.text.value || '').trim();
                    return saveMonitor.zone(saveSection(secId, text));
                }),
            );

            return merge(
                saveIndicator$,
                alertSavingBeforeUnload$,
                populate$,
                save$,
            );
        }),
    );
}
